// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"379":"bb40432b","781":"e8bef173"}[chunkId] + ".css";
};